var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShadowSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14H6C4.89543 14 4 13.1046 4 12V6C4 4.89543 4.89543 4 6 4H12C13.1046 4 14 4.89543 14 6V12C14 13.1046 13.1046 14 12 14Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.50001 15.5H12C13.933 15.5 15.5 13.933 15.5 12V6.50001C15.5 6.46674 15.4995 6.43359 15.4986 6.40054C16.3961 6.91905 17.0001 7.88901 17.0001 9.00005V14.0001C17.0001 15.6569 15.657 17.0001 14.0001 17.0001H9.00011C7.8891 17.0001 6.91915 16.3961 6.40063 15.4986C6.43365 15.4995 6.46677 15.5 6.50001 15.5Z",
    fill: "white",
    fillOpacity: 0.35
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShadowSmall);
export default __webpack_public_path__ + "static/media/icon-shadow-small.54e298792b693fbc0889e7bf018e413b.svg";
export { ForwardRef as ReactComponent };